import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaCalendarAlt } from "react-icons/fa"; // Import the calendar icon from a library like react-icons

const InputSearchDate = ({ name, label, value, onChange, min, readOnly }) => {
  const CustomDatePickerInput = React.forwardRef(({ value, onClick }, ref) => (
    <div className="relative">
      <input
        value={value}
        onChange={onChange}
        min={min}
        className="px-3 py-1 dark:text-gray-300 leading-5 rounded-md focus:border-gray-200 border-gray-200 dark:border-gray-600 focus:ring focus:ring-green-300 dark:focus:border-gray-500 dark:focus:ring-gray-300 border h-10 text-sm focus:outline-none block w-full dark:bg-transparent border-transparent focus:bg-white pr-10" // Added padding for icon
        ref={ref}
        onClick={onClick}
        readOnly={true}
        autoComplete="off"
      />
      {value ? null : (
        <FaCalendarAlt
          className="absolute top-0 right-0 mt-3 mr-3 text-gray-400 cursor-pointer"
          onClick={onClick}
        />
      )}
    </div>
  ));

  return (
    <DatePicker
      isClearable
      selected={value || null}
      onChange={onChange}
      dateFormat="dd/MM/yyyy"
      name={name}
      disabled={readOnly}
      minDate={min}
      customInput={<CustomDatePickerInput />}
      className="!z-20 dark:bg-gray-700"
    />
  );
};

export default InputSearchDate;
